<template>
    <circle-icon
        :class="{ disabled: disabled }"
        size="22"
        icon-size="17"
        :color="checkColor"
        @click="emitClick"
    >
        {{ checkIcon }}
    </circle-icon>
</template>

<script>
    import CircleIcon from '~/components/Shared/UIComponents/CircleIcon';

    export default {
        name: 'CheckIcon',
        components: {
            CircleIcon
        },
        props: {
            value: {},
            readonly: Boolean,
            disabled: Boolean
        },
        computed: {
            checkIcon() {
                return this.value ? 'check' : '';
            },
            checkColor() {
                if (this.disabled) {
                    return this.$xds.theme.grey.darken2;
                }

                return this.value ? this.$xds.theme.success : this.$xds.theme.grey.lighten5;
            }
        },
        methods: {
            emitClick() {
                if (!this.readonly) {
                    this.$emit('click');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    div {
        position: relative;
        border-radius: 100px;

        &.disabled {
            pointer-events: none;
        }
    }
</style>
